module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/view-all-orders-html.json
// module id = 771
// module chunks = 122226506254989